import { modalReducer } from '@sde/core/src/state/modal';

export const reducers = {
  modal: modalReducer,
};
